import { InferQueryOutput } from '~/api/client'
import { ButtonLink, If, Link, PacksDisplayList } from '../index'
import { ToreyPackImage } from './ToreyPack'
import { cx, PackActionButton } from '~/client/components/PacksList/PacksList'
import { Series } from '~/interfaces'
import { useToreyBoxDetails } from './hooks'

export const ToreyBoxes = () => {
  const boxData = useToreyBoxDetails()

  return (
    <div className={cx('container', 'packs-container')}>
      <PacksDisplayList>
        {boxData.data!.map((box) => (
          <ToreyBox key={box.image} {...box} />
        ))}
      </PacksDisplayList>
    </div>
  )
}

export const ToreyBox = (
  props: InferQueryOutput<'series3.boxTypeData'>[number],
) => {
  return (
    <div className={cx('pack-display-container')}>
      <If cond={props.name.includes('Premium')}>
        <strong className={cx('sweep', 'tag-text')}>
          Legendary Refractor Guaranteed
        </strong>
      </If>
        <ToreyPackImage src={props.image!} />
      {/* <Link href={`/packs/${Series.threeBox}/${props.name.toLowerCase()}`}>
      </Link> */}
      <div>
        <h2 className={cx('pack-type')}>{props.name} box</h2>
        <p className={cx('torey-title')}>Bigger Bang | Torey Pudwill</p>
        <h3>${(props.price / 100).toFixed(2)}</h3>
        <p className={cx('is-small')}>
          {props.available}/{props.total} Boxes
        </p>
      </div>
      {/* <PackActionButton
        id={0}
        type={props.name}
        {...props}
        series={Series.threeBox}
      /> */}
      <ButtonLink className={'margin-auto'} href={''}>
        Unavailable
      </ButtonLink>
    </div>
  )
}
